var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"pr-1",attrs:{"title":_vm.trans('booking.isOnlyCanceledInStayin'),"color":"warning"}},[_vm._v("mdi-alert")])}
var staticRenderFns = []

export { render, staticRenderFns }